import React from 'react'
import PropTypes from 'prop-types'
import { LockIcon } from './LockIcon'
import { InfoPopover } from './InfoPopover'

const fmt = n => '$' + n.toFixed(2)

export const PriceCell = ({ item, editing, editPrice, setEditPrice, saving, onStartEdit, onSave, onCancel }) => {
  if (item.priceLocked) {
    return (
      <span className="d-inline-flex align-items-center text-muted" style={{ gap: '6px' }}>
        {fmt(item.effectivePrice)} <LockIcon />
        <InfoPopover royalties={item.royalties} commissions={item.commissions} />
      </span>
    )
  }

  if (editing) {
    const priceVal = parseFloat(editPrice)
    const wouldOverride = !isNaN(priceVal) && Math.abs(priceVal - item.defaultPrice) >= 0.005

    return (
      <span className="d-inline-flex align-items-center flex-nowrap" style={{ gap: '6px' }}>
        <span className="position-relative d-inline-flex align-items-center">
          <span className="position-absolute" style={{ left: '8px', color: '#6b7280', fontSize: '13px', pointerEvents: 'none', zIndex: 1 }}>$</span>
          <input
            type="number"
            step="0.01"
            min={item.minPrice}
            value={editPrice}
            onChange={e => setEditPrice(e.target.value)}
            onKeyDown={e => {
              if (e.key === 'Enter') { e.preventDefault(); onSave() }
              if (e.key === 'Escape') { e.preventDefault(); onCancel() }
            }}
            autoFocus
            className="form-control form-control-sm"
            style={{ width: '90px', paddingLeft: '20px', fontSize: '13px' }}
          />
        </span>
        {wouldOverride && (
          <i
            className="fa-regular fa-undo"
            title="Reset to default"
            style={{ color: '#6b7280', cursor: 'pointer', fontSize: '13px' }}
            onClick={() => setEditPrice(item.defaultPrice.toFixed(2))}
          />
        )}
        <i
          className="fa-regular fa-check"
          title="Save price"
          style={{ color: '#22c55e', cursor: saving ? 'default' : 'pointer', fontSize: '13px' }}
          onClick={saving ? undefined : onSave}
        />
        <InfoPopover royalties={item.royalties} commissions={item.commissions} />
      </span>
    )
  }

  return (
    <span className="cli-price-view d-inline-flex align-items-center" style={{ gap: '6px' }}>
      <span>{fmt(item.effectivePrice)}</span>
      <i
        className="fa-regular fa-pencil cli-edit-btn"
        title="Edit price"
        style={{ color: '#9ca3af', cursor: 'pointer', fontSize: '12px', opacity: 0, transition: 'opacity 0.12s' }}
        onClick={onStartEdit}
      />
      <InfoPopover royalties={item.royalties} commissions={item.commissions} />
    </span>
  )
}

PriceCell.propTypes = {
  item: PropTypes.object.isRequired,
  editing: PropTypes.bool.isRequired,
  editPrice: PropTypes.string.isRequired,
  setEditPrice: PropTypes.func.isRequired,
  saving: PropTypes.bool.isRequired,
  onStartEdit: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
}
